import * as z from "zod/v4";

export const setUnifiedBillingEnabled = {
  name: "setUnifiedBillingEnabled" as const,
  input: z.object({ teamId: z.string(), enabled: z.boolean() }),
  output: z.object({ enabled: z.boolean() }),
};
